const MarketplaceFeedback = () => import("@/pages/marketplace-feedback/index");
const MODULE = "feedback";

const authenticatedRoles = [
  "superadmin",
  "admin",
  "operations",
  "growth",
  "vendor_manager",
  "gardener",
  "gardener_pro",
];

const routes = () => {
  return [
    {
      path: "/marketplace-feedback",
      name: "marketplace-feedback.index",
      component: MarketplaceFeedback,
      meta: {
        module: MODULE,
        permission: authenticatedRoles,
        layout: "app",
      },
    },
  ];
};

export default routes();
